import { Routes, Route } from 'react-router-dom';

import ActivityLogs from '../components/activityLogs/ActivityLogs';
import CommunicationLogs from '../components/communicationLogs';
import Documents from '../components/documents';
import NoAccessData from '../components/documents/components/NoAccessData';
import Mappings from '../components/mappings';
import { CandidateProfile } from '../components/profile';
import Submissions from '../components/submissions';
import { useCandidateViewData } from '../utils/CandidateViewContext';

export const CandidateLayOutChildRoutes = () => {
  const { candidateViewData } = useCandidateViewData();
  const isInDnc: boolean =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);
  return (
    <Routes>
      <Route path="/profile" element={<CandidateProfile />} />
      <Route path="/mappings" element={<Mappings />} />
      <Route path="/submissions" element={isInDnc ? <NoAccessData /> : <Submissions />} />
      <Route path="/documents" element={isInDnc ? <NoAccessData /> : <Documents />} />
      <Route
        path="/communication-logs"
        element={isInDnc ? <NoAccessData /> : <CommunicationLogs />}
      />
      <Route path="/activity-logs" element={isInDnc ? <NoAccessData /> : <ActivityLogs />} />
    </Routes>
  );
};
